import {useState, useEffect, useRef, useCallback} from 'react';
import './Notification.css';

export function Notification({children, active, clazz, id, dismiss})
{
	const [stateActive, setActive] = useState(active);
	const ref = useRef(null);
	const timerRef = useRef(null);

	const onClick = useCallback(() =>
	{
		if(stateActive)
		{
			const div = ref.current;
			if(div)
			{
				const onTransEnd = (evt) =>
				{
					div.removeEventListener('transitionend', onTransEnd);
					// setActive(false);
					if(timerRef.current)
					{
						clearTimeout(timerRef.current);
						timerRef.current = null;
					}

					if(dismiss)
					{
						dismiss({id});
					}
					else
					{
						setActive(false);
					}
				};

				div.addEventListener('transitionend', onTransEnd);
				div.classList.add('is-animating-out');	
			}
		}
	}, [stateActive, dismiss, id]);

	useEffect(() =>
	{
		setActive(active);

		if(active)
		{	
			const div = ref.current;
			if(div.classList.contains('is-animating-in'))
			{
				const k = div.offsetHeight; //force refresh

				const onTransEnd = (evt) =>
				{
					evt.currentTarget.removeEventListener('transitionend', onTransEnd);

					if(!timerRef.current)
					{
						timerRef.current = setTimeout(() =>
						{
							timerRef.current = null;
							onClick();
						}, 8000);
					}
				};

				div.addEventListener('transitionend', onTransEnd);
				div.classList.remove('is-animating-in');
			}
		}

		return () =>
		{
			if(timerRef.current)
			{
				clearTimeout(timerRef.current);
				timerRef.current = null;
			}
		};

	}, [active, onClick]);

	let clazzName = 'notification is-light is-animating-in' + (clazz ? ' ' + clazz : '');
	return (
		stateActive && (
			<div ref={ref} className={clazzName}>
				<button onClick={onClick} className="delete is-medium"></button>
				{children}
			</div>
		) 
	);
}
